import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=794905c1&"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js&"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports